import React from 'react';
import SoftBox from 'components/SoftBox';
import SoftButton from 'components/SoftButton';
import Modal from 'react-bootstrap/Modal';
import PropTypes from 'prop-types';

const DataTableDocumentActionModal = ({ 
    show, 
    handleClose,
    title,
    children,
    handleSubmit,
    isSubmitting
}) => {
    return (
        <Modal
            show={show}
            onHide={handleClose}
            size='lg'
            centered
            backdrop='static'
            backdropClassName='modal-backdrop'
            className='modal-container small'
            style={{ zIndex: 1050 }}
        >
            <Modal.Header>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <SoftBox mt={2}>
                    {children}
                </SoftBox>
            </Modal.Body>

            <Modal.Footer>
                <SoftButton
                    variant="gradient"
                    color="success"
                    onClick={handleSubmit}
                    sx={{ mr: 2 }}
                    disabled={isSubmitting}
                >
                    {isSubmitting ? 'Cargando...' : 'Continuar'}
                </SoftButton>
                <SoftButton
                    variant="gradient"
                    color="error"
                    onClick={handleClose}
                    disabled={isSubmitting}
                >
                    Cancelar
                </SoftButton>
            </Modal.Footer>
        </Modal>
    );
};

DataTableDocumentActionModal.propTypes = {
    show: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
};

export default DataTableDocumentActionModal;